import React, { useState } from 'react';
import InfoRequestModal from './InfoRequestModal';

const KiloterraApproach = () => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  return (
    <>
      <section className="py-20 relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="/_R5A2074.jpg"
            alt="Aerial view of agricultural farmland with barn and equipment"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black bg-opacity-65"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center animate-slide-up">
            <h2 className="text-4xl font-bold text-white mb-8 uppercase">
              The KILOTERRA Approach
            </h2>
            {/* Yellow horizontal line */}
            <div className="flex justify-center mb-8">
              <div className="w-16 h-1 bg-kiloterra-yellow"></div>
            </div>
            <p className="text-lg text-gray-200 max-w-4xl mx-auto leading-relaxed mb-8">
              We back our agents with more than just a strong brand – we have a system that works. Our support team takes on the administrative tasks, so you can stay focused on what matters most—building relationships and closing deals.
            </p>
            <p className="text-lg text-gray-200 max-w-4xl mx-auto leading-relaxed mb-8">
              From day one, you'll get hands-on training and sophisticated marketing that actually moves the needle. Our ongoing mentorship supports your continued growth and provides future leadership opportunities.
            </p>
            <p className="text-lg text-gray-200 max-w-4xl mx-auto leading-relaxed font-medium mb-12">
              You won't be left to figure it out alone. We're in this with you, every step of the way.
            </p>

            <button 
              onClick={() => setIsInfoModalOpen(true)}
              className="bg-kiloterra-yellow text-kiloterra-dark px-12 py-4 font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      <InfoRequestModal 
        isOpen={isInfoModalOpen} 
        onClose={() => setIsInfoModalOpen(false)} 
      />
    </>
  );
};

export default KiloterraApproach;